var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"left-box"},[_c('div',{staticClass:"left-title"},[_vm._v("学期各学院锻炼人数统计")]),_c('div',{staticClass:"echarts"},[_c('div',{style:({
          width: '490px',
          height: '280px',
          margin: '0 auto',
        }),attrs:{"id":"term"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }